(function initVinpostenThemeCartBridge() {
  if (window.__vinpostenThemeCartBridgeActive) return;

  const params = new URLSearchParams(window.location.search);
  const isVinpostenBridge = params.get("vinposten_bridge") === "1";
  const isPaymentBridge = params.get("mundskaenken_payment_bridge") === "1";
  const isResumeBridge = params.get("vinposten_bridge_resume") === "1";
  const isAdminMigrationBridge = isVinpostenBridge &&
    String(params.get("flow") || "").trim().toLowerCase() === "admin_migration";
  const resumeStorageKey = "vinposten-theme-bridge:resume";
  const resumeStorageTtlMs = 15 * 60 * 1000;
  const resumePayload = readStoredResumePayload();
  if (
    !isVinpostenBridge &&
    !isPaymentBridge &&
    !(isResumeBridge && resumePayload) &&
    !(resumePayload && isMitIdValidated())
  ) {
    return;
  }
  window.__vinpostenThemeCartBridgeActive = true;

  const bridgeKeys = [
    "vinposten_bridge",
    "variant_id",
    "customer_id",
    "session_id",
    "flow",
    "vinposten_bridge_resume",
    "mundskaenken_payment_bridge",
    "items",
    "payment_bridge_flow",
    "payment_target",
  ];
  const checkoutPath = "/checkout";
  const dataPath = "/apps/kundeprofil/vinposten/cart-bridge-data";
  const mitIdTriggerId = "vinposten-mitid-trigger";
  const earlyCoverClass = "vinposten-bridge-loading";
  const transitionStorageKey = "vinposten-theme-bridge:transition";
  const preparedStoragePrefix = "vinposten-theme-bridge:prepared:";
  const preparedStorageTtlMs = 15 * 60 * 1000;
  const steadyStatusText = getBridgeCopy().status;

  function getBridgeCopy() {
    const resumeType = resumePayload && resumePayload.bridgeType;
    if (!isPaymentBridge && resumeType !== "payment") {
      return {
        title: "Vi gør din Vinpost klar",
        status: "Vent et øjeblik",
        error: "Vi kunne ikke gøre din Vinpost klar automatisk. Gå til kurven og prøv igen.",
      };
    }
    const flow = String(
      params.get("payment_bridge_flow") ||
      params.get("attributes[source]") ||
      (resumePayload && resumePayload.paymentBridgeFlow) ||
      ""
    ).toLowerCase();
    if (flow.includes("admin_order_supplement") || flow.includes("admin")) {
      return {
        title: "Vi gør betalingen klar",
        status: "På vej til betaling",
        error: "Vi kunne ikke gøre betalingslinket klar automatisk. Gå til kurven og prøv igen.",
      };
    }
    return {
      title: "Vi sender dig til betaling",
      status: "På vej til betaling",
      error: "Vi kunne ikke gøre din betaling klar automatisk. Gå til kurven og prøv igen.",
    };
  }

  function cleanCartUrl() {
    const nextParams = new URLSearchParams(window.location.search);
    bridgeKeys.forEach(function(key) {
      nextParams.delete(key);
    });
    nextParams.set("vinposten_checkout", "1");
    window.history.replaceState(null, "", `${window.location.pathname}?${nextParams.toString()}`);
  }

  function createOverlay() {
    const copy = getBridgeCopy();
    const style = document.createElement("style");
    style.textContent = `
      .vinposten-theme-bridge {
        position: fixed;
        inset: 0;
        z-index: 2147483000;
        display: grid;
        place-items: center;
        padding: 24px;
        background: #53795a;
        color: #f6f1e7;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }

      .vinposten-theme-bridge__card {
        width: min(78vw, 520px);
        display: grid;
        align-content: center;
        justify-items: center;
        gap: 28px;
        padding: 42px 30px;
        border: 1px solid rgba(246, 241, 231, 0.28);
        border-radius: 8px;
        background: rgba(246, 241, 231, 0.06);
        text-align: center;
        box-shadow: 0 18px 60px rgba(20, 35, 25, 0.14);
      }

      .vinposten-theme-bridge__title {
        margin: 0;
        color: #fff8ec;
        font-family: Georgia, "Times New Roman", serif;
        font-size: 44px;
        line-height: 1.04;
      }

      .vinposten-theme-bridge__text {
        display: none;
        max-width: 32rem;
        margin: 22px 0 0;
        color: rgba(246, 241, 231, 0.78);
        font-size: 16px;
        font-weight: 700;
        line-height: 1.45;
      }

      .vinposten-theme-bridge__spinner {
        width: 34px;
        height: 34px;
        border: 3px solid rgba(246, 241, 231, 0.3);
        border-top-color: #fff8ec;
        border-radius: 50%;
        animation: vinpostenThemeBridgeSpin 0.8s linear infinite;
      }

      .vinposten-theme-bridge__button {
        display: none;
        align-items: center;
        justify-content: center;
        min-height: 48px;
        padding: 0 22px;
        border: 0;
        border-radius: 6px;
        background: #fff8ec;
        color: #263a2d;
        font-weight: 900;
        text-decoration: none;
        text-transform: uppercase;
      }

      .vinposten-theme-bridge.is-error .vinposten-theme-bridge__text {
        display: block;
      }

      .vinposten-theme-bridge.is-error .vinposten-theme-bridge__spinner {
        display: none;
      }

      .vinposten-theme-bridge.is-error .vinposten-theme-bridge__button {
        display: inline-flex;
      }

      .vinposten-theme-bridge__button--trigger,
      .vinposten-theme-bridge.is-error .vinposten-theme-bridge__button--trigger {
        display: none;
      }

      .vinposten-theme-bridge__trigger-form {
        display: none;
      }

      @keyframes vinpostenThemeBridgeSpin {
        to { transform: rotate(360deg); }
      }

      @media (max-width: 680px) {
        .vinposten-theme-bridge {
          padding: 16px;
        }

        .vinposten-theme-bridge__card {
          width: min(82vw, 420px);
          padding: 34px 22px;
        }

        .vinposten-theme-bridge__title {
          font-size: 34px;
        }
      }
    `;
    document.head.appendChild(style);

    const overlay = document.createElement("div");
    overlay.className = "vinposten-theme-bridge";
    overlay.innerHTML = `
      <section class="vinposten-theme-bridge__card" role="status" aria-live="polite">
        <h1 class="vinposten-theme-bridge__title">${copy.title}</h1>
        <p class="vinposten-theme-bridge__text" data-vinposten-bridge-status aria-label="${steadyStatusText}">${steadyStatusText}</p>
        <div class="vinposten-theme-bridge__spinner" aria-hidden="true"></div>
        <form class="vinposten-theme-bridge__trigger-form" method="post" action="/cart">
          <button class="vinposten-theme-bridge__button vinposten-theme-bridge__button--trigger" id="${mitIdTriggerId}" type="submit" name="checkout">
            Åbn alderskontrol
          </button>
        </form>
        <a class="vinposten-theme-bridge__button" href="/cart">Se kurv</a>
      </section>
    `;
    document.body.appendChild(overlay);
    return overlay;
  }

  function releaseEarlyCover() {
    document.documentElement.classList.remove(earlyCoverClass);
    document.documentElement.classList.remove("mundskaenken-payment-bridge-loading");
  }

  function setStatus(overlay) {
    const status = overlay.querySelector("[data-vinposten-bridge-status]");
    if (status) status.setAttribute("aria-label", steadyStatusText);
  }

  function setError(overlay, text) {
    const status = overlay.querySelector("[data-vinposten-bridge-status]");
    overlay.classList.add("is-error");
    if (status) status.textContent = text || "Vi kunne ikke gøre din Vinpost klar. Prøv igen.";
    releaseEarlyCover();
  }

  function fetchWithTimeout(url, options) {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(function() {
      controller.abort();
    }, 10000);

    return window.fetch(url, Object.assign({}, options, { signal: controller.signal }))
      .finally(function() {
        window.clearTimeout(timeoutId);
      });
  }

  function buildDataUrl() {
    const dataUrl = new URL(dataPath, window.location.origin);
    ["variant_id", "customer_id", "session_id", "flow"].forEach(function(key) {
      const value = params.get(key);
      if (value) dataUrl.searchParams.set(key, value);
    });
    return dataUrl.toString();
  }

  function wait(delayMs) {
    return new Promise(function(resolve) {
      window.setTimeout(resolve, delayMs);
    });
  }

  async function fetchVinpostenBridgeData() {
    const maxAttempts = isAdminMigrationBridge ? 3 : 1;
    let lastResult = null;

    for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
      try {
        const response = await fetchWithTimeout(buildDataUrl(), {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
          },
        });
        const result = await response.json().catch(function() {
          return null;
        });

        if (response.ok && result && result.ok === true && result.payload) {
          return result;
        }
        lastResult = result;
      } catch (error) {
        if (attempt === maxAttempts) throw error;
      }

      if (attempt < maxAttempts) {
        await wait(300 * attempt);
      }
    }

    if (lastResult && lastResult.redirect && !isAdminMigrationBridge) {
      window.location.replace(lastResult.redirect);
      return null;
    }
    throw new Error((lastResult && lastResult.error) || "bridge data failed");
  }

  function collectBracketParams(prefix) {
    const values = {};
    params.forEach(function(value, key) {
      if (!key.startsWith(prefix + "[") || !key.endsWith("]")) return;
      const field = key.slice(prefix.length + 1, -1);
      if (!field) return;
      values[field] = value;
    });
    return values;
  }

  function parsePaymentBridgeItems() {
    return String(params.get("items") || "")
      .split(",")
      .map(function(part) {
        const pieces = String(part || "").split(":");
        const variantId = decodeURIComponent(String(pieces[0] || "")).trim();
        const quantity = Math.max(1, Number(decodeURIComponent(String(pieces[1] || "1")).trim() || 1));
        if (!variantId || !Number.isFinite(quantity) || quantity <= 0) return null;
        return {
          variantId: variantId,
          quantity: quantity,
        };
      })
      .filter(Boolean);
  }

  function buildCheckoutTargetPath(discountCode) {
    const checkoutParams = new URLSearchParams();
    params.forEach(function(value, key) {
      if (key.startsWith("checkout[")) checkoutParams.set(key, value);
    });
    const checkoutTarget = checkoutParams.toString()
      ? `${checkoutPath}?${checkoutParams.toString()}`
      : checkoutPath;
    const discount = String(discountCode || "").trim();
    if (!discount) return checkoutTarget;
    return `/discount/${encodeURIComponent(discount)}?redirect=${encodeURIComponent(checkoutTarget)}`;
  }

  function normalizePaymentTargetPath(value) {
    const rawTarget = String(value || "").trim();
    if (!rawTarget) return "";
    try {
      const targetUrl = new URL(rawTarget, window.location.origin);
      if (targetUrl.origin !== window.location.origin) return "";
      const path = `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;
      if (!targetUrl.pathname.includes("/invoices/") && !targetUrl.pathname.startsWith("/checkouts/")) return "";
      return path;
    } catch (error) {
      return "";
    }
  }

  function normalizeCheckoutPath(value) {
    const rawTarget = String(value || "").trim();
    if (!rawTarget) return "";
    try {
      const targetUrl = new URL(rawTarget, window.location.origin);
      if (targetUrl.origin !== window.location.origin) return "";
      const path = `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;
      if (
        targetUrl.pathname === "/checkout" ||
        targetUrl.pathname.startsWith("/checkout/") ||
        targetUrl.pathname.startsWith("/checkouts/") ||
        targetUrl.pathname === "/cart" ||
        targetUrl.pathname.startsWith("/discount/") ||
        targetUrl.pathname.includes("/invoices/")
      ) {
        return path;
      }
      return "";
    } catch (error) {
      return "";
    }
  }

  function removeStoredResumePayload() {
    try {
      window.sessionStorage.removeItem(resumeStorageKey);
    } catch (error) {}
  }

  function readStoredResumePayload() {
    try {
      const raw = window.sessionStorage.getItem(resumeStorageKey);
      if (!raw) return null;
      const saved = JSON.parse(raw);
      if (!saved || !saved.timestamp || Date.now() - saved.timestamp > resumeStorageTtlMs) {
        removeStoredResumePayload();
        return null;
      }
      const checkoutTarget = normalizeCheckoutPath(saved.checkoutPath);
      if (!checkoutTarget) {
        removeStoredResumePayload();
        return null;
      }
      const lineItems = Array.isArray(saved.lineItems)
        ? saved.lineItems.map(function(item) {
            const variantId = String(item && item.variantId || "").trim();
            const quantity = Math.max(1, Number(item && item.quantity || 1));
            if (!variantId || !Number.isFinite(quantity) || quantity <= 0) return null;
            return {
              variantId: variantId,
              quantity: quantity,
              properties: item.properties || {},
              sellingPlanId: item.sellingPlanId || "",
            };
          }).filter(Boolean)
        : [];
      return {
        checkoutPath: checkoutTarget,
        bridgeType: saved.bridgeType === "payment" ? "payment" : "vinposten",
        paymentBridgeFlow: String(saved.paymentBridgeFlow || ""),
        lineItems: lineItems,
        variantId: String(saved.variantId || ""),
        quantity: Math.max(1, Number(saved.quantity || 1)),
        sellingPlanId: saved.sellingPlanId || "",
        properties: saved.properties || {},
        attributes: saved.attributes || {},
        note: String(saved.note || ""),
        clearCart: saved.clearCart === true,
        directCheckout: saved.directCheckout === true,
      };
    } catch (error) {
      return null;
    }
  }

  function storeResumePayload(payload) {
    const checkoutTarget = normalizeCheckoutPath(payload && payload.checkoutPath || checkoutPath);
    if (!checkoutTarget) return "";
    try {
      window.sessionStorage.setItem(resumeStorageKey, JSON.stringify({
        timestamp: Date.now(),
        checkoutPath: checkoutTarget,
        bridgeType: isPaymentBridge ? "payment" : "vinposten",
        paymentBridgeFlow: String(payload && payload.paymentBridgeFlow || params.get("payment_bridge_flow") || ""),
        lineItems: Array.isArray(payload && payload.lineItems) ? payload.lineItems : [],
        variantId: String(payload && payload.variantId || ""),
        quantity: Math.max(1, Number(payload && payload.quantity || 1)),
        sellingPlanId: payload && payload.sellingPlanId || "",
        properties: payload && payload.properties || {},
        attributes: payload && payload.attributes || {},
        note: String(payload && payload.note || ""),
        clearCart: payload && payload.clearCart === true,
        directCheckout: payload && payload.directCheckout === true,
      }));
    } catch (error) {}
    return checkoutTarget;
  }

  function buildMitIdReturnUrl() {
    const returnUrl = new URL("/cart", window.location.origin);
    returnUrl.searchParams.set("vinposten_bridge_resume", "1");
    return returnUrl.toString();
  }

  function resolvePaymentBridgePayload() {
    const attributes = collectBracketParams("attributes");
    const note = String(params.get("note") || "").trim();
    const discountCode = String(params.get("discount") || "").trim();
    const paymentTarget = normalizePaymentTargetPath(params.get("payment_target"));
    if (paymentTarget) {
      return {
        directCheckout: true,
        clearCart: false,
        attributes: attributes,
        note: note,
        discountCode: discountCode,
        checkoutPath: paymentTarget,
        paymentBridgeFlow: String(params.get("payment_bridge_flow") || "").trim(),
      };
    }

    const lineItems = parsePaymentBridgeItems();
    if (!lineItems.length) throw new Error("missing items");
    return {
      lineItems: lineItems,
      clearCart: true,
      attributes: attributes,
      note: note,
      discountCode: discountCode,
      checkoutPath: buildCheckoutTargetPath(discountCode),
      paymentBridgeFlow: String(params.get("payment_bridge_flow") || "").trim(),
    };
  }

  function isMitIdValidated() {
    try {
      return typeof mitid_validated !== "undefined" && mitid_validated === true;
    } catch (error) {
      return false;
    }
  }

  function getPreparedStorageKey(payload) {
    const lineItems = Array.isArray(payload && payload.lineItems)
      ? payload.lineItems.map(function(item) {
          return [
            item && item.variantId,
            item && item.quantity,
            item && item.sellingPlanId,
          ].join("x");
        }).join(",")
      : "";
    const parts = [
      isPaymentBridge ? "payment" : "vinposten",
      lineItems,
      payload && payload.variantId,
      payload && payload.sellingPlanId,
      params.get("customer_id") || "",
      params.get("session_id") || "",
      params.get("flow") || "",
      params.get("payment_bridge_flow") || "",
      params.get("payment_target") || "",
      params.get("discount") || "",
    ];
    return preparedStoragePrefix + parts.map(function(part) {
      return encodeURIComponent(String(part || ""));
    }).join(":");
  }

  function isCartPrepared(payload) {
    try {
      const raw = window.sessionStorage.getItem(getPreparedStorageKey(payload));
      if (!raw) return false;
      const saved = JSON.parse(raw);
      if (!saved || !saved.timestamp || Date.now() - saved.timestamp > preparedStorageTtlMs) {
        window.sessionStorage.removeItem(getPreparedStorageKey(payload));
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  function markCartPrepared(payload) {
    try {
      window.sessionStorage.setItem(getPreparedStorageKey(payload), JSON.stringify({
        timestamp: Date.now(),
      }));
    } catch (error) {
      // Session storage is only a duplicate guard. The checkout flow can continue without it.
    }
  }

  function waitForMitIdApp(timeoutMs) {
    const start = Date.now();
    return new Promise(function(resolve, reject) {
      function check() {
        if (
          typeof window.mitIdShowForm === "function" &&
          document.getElementById("mitid-app") &&
          document.getElementById("mitid-button")
        ) {
          resolve();
          return;
        }
        if (Date.now() - start > timeoutMs) {
          reject(new Error("mitid app unavailable"));
          return;
        }
        window.setTimeout(check, 100);
      }
      check();
    });
  }

  function waitForVisibleMitIdDialog(timeoutMs) {
    const start = Date.now();
    return new Promise(function(resolve, reject) {
      function check() {
        const app = document.getElementById("mitid-app");
        if (app) {
          const style = window.getComputedStyle(app);
          const rect = app.getBoundingClientRect();
          if (
            !app.classList.contains("mitid-hide") &&
            style.display !== "none" &&
            style.visibility !== "hidden" &&
            style.opacity !== "0" &&
            rect.width > 0 &&
            rect.height > 0
          ) {
            resolve();
            return;
          }
        }
        if (Date.now() - start > timeoutMs) {
          reject(new Error("mitid dialog unavailable"));
          return;
        }
        window.setTimeout(check, 50);
      }
      check();
    });
  }

  function setMitIdReturnUrl(returnUrl) {
    const targetUrlInput = document.getElementById("mitIdTargetUrl");
    if (targetUrlInput) targetUrlInput.value = returnUrl;
  }

  function bindMitIdReturnUrl(returnUrl) {
    const form = document.querySelector("#mitid-app form");
    const button = document.getElementById("mitid-button");
    const setReturnUrlBeforeSubmit = function() {
      setMitIdReturnUrl(returnUrl);
    };
    if (form) form.addEventListener("submit", setReturnUrlBeforeSubmit, true);
    if (button) button.addEventListener("click", setReturnUrlBeforeSubmit, true);
  }

  function markTransition() {
    try {
      window.sessionStorage.setItem(transitionStorageKey, String(Date.now()));
    } catch (error) {}
  }

  async function openMitIdOnBridge(overlay, payload, readyPromise) {
    setStatus(overlay);
    if (readyPromise) {
      const readyResult = await readyPromise;
      if (readyResult && readyResult.ok === false) throw readyResult.error || new Error("mitid app unavailable");
    } else {
      await waitForMitIdApp(6000);
    }

    const trigger = document.getElementById(mitIdTriggerId);
    if (!trigger) throw new Error("missing mitid trigger");

    storeResumePayload(payload);
    const returnUrl = buildMitIdReturnUrl();
    setMitIdReturnUrl(returnUrl);
    bindMitIdReturnUrl(returnUrl);
    markTransition();
    window.mitIdShowForm({
      target: trigger,
      preventDefault: function() {},
      stopImmediatePropagation: function() {},
    });
    await waitForVisibleMitIdDialog(6000);
    releaseEarlyCover();
    [0, 100, 300, 800, 1500, 3000, 5000].forEach(function(delay) {
      window.setTimeout(function() {
        setMitIdReturnUrl(returnUrl);
      }, delay);
    });
  }

  function getCartItems(payload) {
    if (Array.isArray(payload && payload.lineItems) && payload.lineItems.length) {
      return payload.lineItems
        .map(function(item) {
          const variantId = Number(item && (item.variantId || item.variant_id));
          const quantity = Math.max(1, Number(item && item.quantity || 1));
          if (!Number.isFinite(variantId) || !(variantId > 0) || !Number.isFinite(quantity) || !(quantity > 0)) {
            return null;
          }
          const cartItem = {
            id: variantId,
            quantity: quantity,
            properties: item.properties || {},
          };
          if (item.sellingPlanId || item.selling_plan) {
            cartItem.selling_plan = Number(item.sellingPlanId || item.selling_plan);
          }
          return cartItem;
        })
        .filter(Boolean);
    }

    if (!payload || !payload.variantId) return [];
    const cartItem = {
      id: Number(payload.variantId),
      quantity: Number(payload.quantity || 1),
      properties: payload.properties || {},
    };
    if (payload.sellingPlanId) cartItem.selling_plan = Number(payload.sellingPlanId);
    return [cartItem];
  }

  async function prepareBridgeCart(payload) {
    if (payload && payload.directCheckout === true) return;

    const cartItems = getCartItems(payload);
    if (!cartItems.length) {
      throw new Error("missing variant");
    }
    if (payload.requiresSellingPlan && !payload.sellingPlanId) {
      throw new Error("missing selling plan");
    }
    if (isCartPrepared(payload)) return;

    if (payload.clearCart === true) {
      await fetchWithTimeout("/cart/clear.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
    }

    const addResponse = await fetchWithTimeout("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: cartItems }),
    });

    if (!addResponse.ok) {
      throw new Error("cart add failed");
    }

    const updatePayload = {
      attributes: payload.attributes || {},
    };
    if (payload.note) updatePayload.note = payload.note;

    await fetchWithTimeout("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatePayload),
    });

    markCartPrepared(payload);
  }

  async function continueToCheckout(payload) {
    await prepareBridgeCart(payload);
    const checkoutTarget = normalizeCheckoutPath(payload && payload.checkoutPath || checkoutPath) || checkoutPath;
    if (isVinpostenBridge || isPaymentBridge || isResumeBridge) cleanCartUrl();
    removeStoredResumePayload();
    markTransition();
    window.location.replace(checkoutTarget);
  }

  async function runBridge() {
    const overlay = createOverlay();

    try {
      if (!isVinpostenBridge && !isPaymentBridge && resumePayload) {
        if (!isMitIdValidated()) throw new Error("mitid resume without validation");
        setStatus(overlay);
        await continueToCheckout(resumePayload);
        return;
      }

      let result = null;
      if (isPaymentBridge) {
        result = {
          ok: true,
          payload: resolvePaymentBridgePayload(),
        };
      } else {
        result = await fetchVinpostenBridgeData();
        if (!result) return;
      }

      if (result.payload.ageVerificationBypass === true) {
        setStatus(overlay);
        await continueToCheckout(result.payload);
        return;
      }

      if (!isMitIdValidated()) {
        setStatus(overlay);
        const mitIdReady = waitForMitIdApp(6000)
          .then(function() {
            return { ok: true };
          })
          .catch(function(error) {
            return { ok: false, error: error };
          });
        storeResumePayload(result.payload);
        await prepareBridgeCart(result.payload);
        await openMitIdOnBridge(overlay, result.payload, mitIdReady);
        return;
      }

      setStatus(overlay);
      await continueToCheckout(result.payload);
    } catch (error) {
      setError(overlay, getBridgeCopy().error);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runBridge, { once: true });
  } else {
    runBridge();
  }
})();
